import { combineReducers } from "redux"
// Authentication
//import Login from "./auth/login/reducer"
//sucursales
import Usuario from "./users/registro/reducer"
import Login from "./auth/login/reducer"
import Loader from "./loading/reducer"
import Loads from "./loads/reducer"
import ReportsRequest from "./reports/reducer"
//Configuracion de acciones de titulos y titulo
//import Titles from "./titles/reducer"

const rootReducer = combineReducers({
  Login,
  Usuario,
  Loader,
  Loads,
  ReportsRequest
})

export default rootReducer
